export default __webpack_public_path__ + "static/media/icon-plus.278c048a.svg";